module.exports = __webpack_public_path__ + "static/img/post3.2627a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post3.png
// module id = Z9Zh
// module chunks = 192